
import * as ipxRuntime$q93M734xvI from 'C:/Projects/HUB/src/PublicSite/client-app/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "img.youtube.com",
    "i.vimeocdn.com"
  ],
  "alias": {
    "/youtube": "https://img.youtube.com",
    "/vimeo": "https://i.vimeocdn.com"
  },
  "densities": [
    1,
    2,
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 100
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$q93M734xvI, defaults: {} }
}
        